import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchPost } from "../lib/api";
import Seo from "../components/Seo";
import { ArrowLeft } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    setPost(null); setError(false);
    fetchPost(slug).then(setPost).catch(() => setError(true));
  }, [slug]);

  if (error) return <div className="max-w-3xl mx-auto px-4 py-32 text-center text-[#4B5563]">Post not found.</div>;
  if (!post) return <div className="max-w-3xl mx-auto px-4 py-32 text-center text-[#9CA3AF]">Loading…</div>;

  const schema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": post.title,
    "image": post.featured_image,
    "datePublished": post.published_at,
    "dateModified": post.updated_at,
    "author": { "@type": "Person", "name": post.author || "Akram" },
    "publisher": { "@type": "Organization", "name": "Lime Driving School" },
    "description": post.meta_description || post.excerpt,
  };

  return (
    <>
      <Seo title={post.meta_title || post.title} description={post.meta_description || post.excerpt} robots={post.meta_robots} jsonLd={schema} />
      <article className="py-20 md:py-28 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-testid="blog-post-page">
        <Link to="/blog" className="inline-flex items-center gap-1 text-sm text-[#4B5563] hover:text-white"><ArrowLeft className="h-4 w-4" /> All posts</Link>
        <span className="block mt-8 text-xs uppercase tracking-[0.2em] font-semibold text-[#37B160]">{post.category}</span>
        <h1 className="mt-3 text-4xl sm:text-5xl tracking-tight leading-tight font-medium" style={{fontFamily:"Outfit, sans-serif"}}>{post.title}</h1>
        <div className="mt-4 text-sm text-[#9CA3AF]">By {post.author} · {new Date(post.published_at).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}</div>
        {post.featured_image && (
          <img src={post.featured_image} alt={post.title} className="mt-10 w-full rounded-2xl border border-black/5" />
        )}
        <div className="prose prose-neutral max-w-none mt-10 text-[#111827]"
             style={{ fontFamily: "Manrope, system-ui, sans-serif" }}
             data-testid="post-body"
             dangerouslySetInnerHTML={{ __html: post.body_html }} />
      </article>
    </>
  );
}
